import { combineReducers } from "redux";
import {
  Address,
  Addresses,
  Admin,
  BookingType,
  Cart,
  Category,
  Config,
  Coupon,
  Customer,
  CustomerId,
  Dates,
  DeliveryDate,
  LoggedIn,
  Note,
  OngoingOrders,
  OrderType,
  OrderTypeId,
  OrderTypes,
  PickupDate,
  Processing,
  Role,
  SelfPick,
  Service,
  Store,
  Token,
  UserType,
  Zone,
} from "./Reducers";

export const rootReducer = combineReducers({
  LoggedIn: LoggedIn,
  Token: Token,
  OrderType: OrderType,
  BookingType: BookingType,
  OrderTypes: OrderTypes,
  OrderTypeId: OrderTypeId,
  Processing: Processing,
  Service: Service,
  Category: Category,
  Cart: Cart,
  Config: Config,
  Customer: Customer,
  CustomerId: CustomerId,
  SelfPick: SelfPick,
  Zone: Zone,
  PickupDate: PickupDate,
  DeliveryDate: DeliveryDate,
  Coupon: Coupon,
  // Map: Map,
  Address: Address,
  Addresses: Addresses,
  Dates: Dates,
  UserType: UserType,
  Note: Note,
  OngoingOrders: OngoingOrders,
  Admin: Admin,
  Store: Store,
  Role: Role,
});
